var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32882 0.095258L5.75429 0.631781C5.61832 0.758765 5.61832 0.96466 5.75429 1.09167L10.2558 5.29544H0.348214C0.155913 5.29544 0 5.44104 0 5.62062V6.37938C0 6.55896 0.155913 6.70456 0.348214 6.70456H10.2558L5.75429 10.9084C5.61832 11.0353 5.61832 11.2412 5.75429 11.3682L6.32882 11.9048C6.46479 12.0317 6.68527 12.0317 6.82128 11.9048L12.898 6.22995C13.034 6.10297 13.034 5.89708 12.898 5.77007L6.82125 0.095258C6.68527 -0.0317527 6.46479 -0.0317527 6.32882 0.095258Z",
    fill: "url(#paint0_linear_1299_514)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1299_514",
    x1: 6.5,
    y1: 0,
    x2: 6.5,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "top-stop",
    offset: 0.0208333,
    stopColor: "#7E30E1"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "bottom-stop",
    offset: 0.911458,
    stopColor: "#0072F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.5601a2e849ba953201f438aafb4e7c30.svg";
export { ForwardRef as ReactComponent };